import { render, staticRenderFns } from "./task-update-modal.vue?vue&type=template&id=5d30829e&scoped=true"
import script from "./task-update-modal.vue?vue&type=script&lang=js"
export * from "./task-update-modal.vue?vue&type=script&lang=js"
import style0 from "./task-update-modal.vue?vue&type=style&index=0&id=5d30829e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30829e",
  null
  
)

export default component.exports